// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2898":"8bc7dff9","9250":"d5950e54","9346":"c9fde56c","9395":"f444a95e"}[chunkId] + ".chunk.css";
};